import React from 'react';
import { Container, Card, Row, Col, Badge } from 'react-bootstrap';

function About() {
  const timelineEvents = [
    { year: "1995", event: "ولدت في الرياض، المملكة العربية السعودية" },
    { year: "2010", event: "بدأت اهتمامي بالإعلام من خلال متابعة الأحداث المحلية" },
    { year: "2015", event: "انضممت إلى فريق إعلامي كمراسل ميداني" },
    { year: "2018", event: "حصلت على شهادة في الإعلام من جامعة الملك سعود" },
    { year: "2019", event: "بدأت العمل كمحلل إعلامي في قناة محلية" },
    { year: "2020", event: "انتقلت إلى مجال بناء القدرات البشرية كخبير" },
    { year: "2021", event: "أسست برنامجًا تدريبيًا لتطوير مهارات الشباب" },
    { year: "2022", event: "أصبحت مستشارًا للتطوير التنظيمي في عدة شركات" },
    { year: "2023", event: "طورت استراتيجيات تواصل لمؤسسات حكومية" },
    { year: "2025", event: "أطلقت مبادرة إقليمية لتعزيز التواصل الاستراتيجي" },
  ];

  return (
    <div className="about-page">
      <div className="overlay"></div>
      <Container className="py-5 position-relative page-content">
        <h2 className="text-center mb-5 page-title">السيرة الذاتية</h2>
        <Row>
          <Col md={4}>
            <Card className="about-card mb-4 shadow-lg">
              <Card.Img variant="top" src="./hamadpp.jpg" alt="Hamad Al Muneef" />
              <Card.Body>
                <Card.Title>حمد المنيف</Card.Title>
                <Card.Text className="text-gray">
                  إعلامي سعودي 🇸🇦 | خبير بناء القدرات البشرية | مستشار التطوير التنظيمي والموارد البشرية | مستشار التواصل الاستراتيجي
                </Card.Text>
                <Badge bg="secondary" className="me-1">إعلامي</Badge>
                <Badge bg="secondary" className="me-1">مستشار</Badge>
                <Badge bg="secondary">خبير</Badge>
              </Card.Body>
            </Card>
          </Col>
          <Col md={8}>
            <div className="text-bg-blur">
              <h3 className="mb-4">نبذة عني</h3>
              <p className="text-gray mb-4">
                أنا حمد المنيف، إعلامي سعودي وُلدت في مدينة الرياض عام 1995. بدأت رحلتي في عالم الإعلام منذ سن مبكرة، حيث كنت أتابع الأخبار وأحلل الأحداث بعين ناقدة. مع الوقت، تطورت اهتماماتي لتشمل العمل الميداني كمراسل، ثم انتقلت للعمل كمحلل إعلامي، مما أكسبني خبرة واسعة في صياغة الرسائل الإعلامية وتحليل التأثير.
              </p>
              <p className="text-gray mb-4">
                في عام 2020، اتجهت نحو بناء القدرات البشرية، حيث أدركت أهمية تطوير الأفراد كأساس لنجاح أي منظومة. عملت على تصميم برامج تدريبية مبتكرة تستهدف الشباب والمؤسسات على حد سواء، مع التركيز على تعزيز المهارات القيادية والتواصلية.
              </p>
              <p className="text-gray mb-4">
                كمستشار للتطوير التنظيمي والموارد البشرية، قدمت حلولاً استراتيجية للعديد من الشركات والمؤسسات الحكومية، حيث ركزت على تحسين الهياكل التنظيمية، تطوير سياسات الموارد البشرية، وتعزيز بيئة العمل. شغفي بالتواصل الاستراتيجي دفعني لتقديم استشارات تساعد المؤسسات على بناء جسور تواصل فعّالة مع جمهورها.
              </p>
              <p className="text-gray">
                اليوم، أعمل على مبادرات إقليمية تهدف إلى تعزيز دور التواصل في تحقيق الأهداف التنموية، مع التزامي بتقديم محتوى إعلامي هادف يعكس رؤيتي للمستقبل. للتواصل: <a href="mailto:Hamad1452@hotmail.com" className="text-white">Hamad1452@hotmail.com</a>
              </p>
              <h3 className="mt-5 mb-4">الجدول الزمني</h3>
              <div className="timeline-tree">
                {timelineEvents.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <span className="timeline-year">{item.year}</span>
                    <p className="text-gray">{item.event}</p>
                  </div>
                ))}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default About;